export { StarRating } from "./star-rating";
